module.exports = __webpack_public_path__ + "img/play-icon.435681dc.svg";